import { getCategory, type AnimeItem } from "@/mocks/anime";

export default function AnimeCard({ anime }: { anime: AnimeItem }) {
  const cat = getCategory(anime.category);
  return (
    <article className="group overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1">
      <div className="relative aspect-[2/3] w-full overflow-hidden bg-background-100">
        <img
          src={anime.cover}
          alt={`${anime.title} 高清番剧海报`}
          title={`${anime.title} · 补番推荐`}
          loading="lazy"
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-foreground-950/70 px-2 py-0.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          {anime.rating} 分
        </span>
        <span
          className={`absolute right-2 top-2 rounded-md px-2 py-0.5 text-xs font-medium text-background-50 ${
            anime.status === "完结" ? "bg-secondary-500" : "bg-accent-500 text-foreground-900"
          }`}
        >
          {anime.status}
        </span>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="font-display text-base text-foreground-950 md:text-lg">
          {anime.title}
        </h3>
        <p className="mt-0.5 truncate text-xs text-foreground-500">{anime.titleEn}</p>
        <div className="mt-2.5 flex flex-wrap items-center gap-1.5">
          {anime.genres.slice(0, 3).map((g) => (
            <span
              key={g}
              className="rounded-full bg-background-100 px-2 py-0.5 text-xs text-foreground-700"
            >
              {g}
            </span>
          ))}
          <span className="text-xs text-foreground-400">
            {anime.year} · {anime.episodes}
          </span>
        </div>
        {cat && (
          <div className="mt-2 text-xs text-primary-600">
            <i className="ri-price-tag-3-line mr-1 align-[-1px]" aria-hidden="true"></i>
            {cat.name}
          </div>
        )}
      </div>
    </article>
  );
}